/* eslint-disable react/prop-types */
import React from "react";
import { Divider, Layout, Typography, Row, Col, Statistic } from "antd";
import functions from "../../../components/utils/functions";

const { Content } = Layout;

const { Title } = Typography;

const formatRevenue = (n) =>
  `₹${functions.formatIndianNumber(Number(n) || 0, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const Sales = ({ revenue, netPayout }) => {
  const value = Number(revenue) || 0;
  const payout = Number(netPayout) || 0;
  const shorted = Math.max(0, value - payout);
  return (
    <Content
      className="vc-panel"
      style={{
        padding: 24,
        marginTop: 20,
      }}
    >
      <Title level={4}>Sales</Title>
      <Divider />
      <Row gutter={16}>
        <Col
          className="gutter-row"
          xs={{ span: 12 }}
          lg={{ span: 8 }}
          style={{ padding: "16px" }}
        >
          <Statistic title="Net Revenue" value={formatRevenue(value)} />
        </Col>
        <Col
          className="gutter-row"
          xs={{ span: 12 }}
          lg={{ span: 8 }}
          style={{ padding: "16px" }}
        >
          <Statistic title="SHORTED" value={formatRevenue(shorted)} />
        </Col>
        <Col
          className="gutter-row vc-panel-highlight"
          xs={{ span: 24 }}
          lg={{ span: 8 }}
          style={{
            padding: "16px",
          }}
        >
          <Statistic title="Net Payout" value={formatRevenue(payout)} />
        </Col>
      </Row>
    </Content>
  );
};
export default Sales;
